import React from "react"
import 'twin.macro'
import { Component } from "react"
import { debounce } from "lodash-es"
import PropTypes from "prop-types"

class DebounceInput extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    delay: PropTypes.number,
  }

  static defaultProps = {
    value: ``,
    delay: 500,
  }

  state = {
    inputValue: ``,
  }

  componentDidMount() {
    this.setInputValue(this.props.value)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value)
      this.setInputValue(this.props.value)
  }

  setInputValue = (value = ``) => {
    this.setState({ inputValue: value })
  }

  onChangeInputText = e => {
    this.setInputValue(e.target.value)
    e.persist()
    this.debounceOnChange()
  }

  onChangeValue = () => {
    this.props.onChange(this.state.inputValue)
  }

  debounceOnChange = debounce(this.onChangeValue, this.props.delay)

  render() {
    const { inputValue } = this.state
    return (
      <div
        tw="rounded-md bg-thirdgray-200 flex items-center px-3 border-2 border-transparent border-solid focus-within:(bg-white border-blue-400) dark:(bg-thirdgray-dark-200 focus-within:(bg-black border-blue-700))">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" tw="mr-1">
          <path fill="#7C8FB1" d="M5 0a5 5 0 014.172 7.757l1.246 1.245c.36-.02.725.09 1.02.328l.123.11 3.5 3.5a1.5 1.5 0 01-2.008 2.224l-.114-.103-3.5-3.5a1.496 1.496 0 01-.437-1.143L7.757 9.172A5 5 0 115 0zm0 2a3 3 0 100 6 3 3 0 000-6z" />
        </svg>
        <input
          {...this.props}
          type="text"
          value={inputValue}
          onChange={this.onChangeInputText}
          tw="appearance-none bg-transparent py-1 border-0 text-thirdgray-500 text-base w-44 md:(w-52) lg:(w-80) focus:(outline-none) dark:(text-thirdgray-dark-500)"
        />  
      </div>
      
    )
  }
}

export default DebounceInput